import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { fetchAdminShowsPublic } from '@/hooks/useAdminShows';
import { fetchShowTags } from '@/hooks/useShowTags';

/**
 * Förladdar data för sidor så att laddningsskelettet oftast aldrig hinner visas.
 */
export const usePagePrefetch = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (path: string) => {
      if (path === '/forestallningar') {
        queryClient.prefetchQuery({
          queryKey: ['admin-shows-public'],
          queryFn: fetchAdminShowsPublic,
          staleTime: 60 * 1000,
        });
        queryClient.prefetchQuery({
          queryKey: ['show-tags'],
          queryFn: fetchShowTags,
          staleTime: 60 * 1000,
        });
      }
    },
    [queryClient]
  );
};
